<nav #navigationMain>
  <mat-toolbar>
    <mat-toolbar-row class="mat-toolbar-row-padding flex flex-start-stretch">
      <div class="navigation-logo flex flex-start-center max-sm:hidden" data-test-id="navigation-logo">
        <a class="flex" routerLink="/"><img alt="7N Logo" src="assets/images/7n-logo-white.svg" /></a>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</nav>
